import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { santaClaraTheme } from 'theme/old-santaClaraLightTheme';
import { App } from './App';
import './index.css';
import 'assets/css/fonts.css';

document.documentElement.style.setProperty(
  '--scfhp-interactive-action-primary',
  santaClaraTheme.colors.interactive.action.primary,
);
document.documentElement.style.setProperty(
  '--scfhp-onsurface-icon-primary',
  santaClaraTheme.colors.onSurface.icon.primary,
);
document.documentElement.style.setProperty(
  '--scfhp-onsurface-text-primary',
  santaClaraTheme.colors.onSurface.text.primary,
);
document.documentElement.style.setProperty(
  '--scfhp-onsurface-border-subdued',
  santaClaraTheme.colors.onSurface.border.subdued,
);
document.documentElement.style.setProperty(
  '--scfhp-surface-background-secondary',
  santaClaraTheme.colors.surface.background.secondary,
);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
